<template>
  <div class="relative">
    <input
      ref="input"
      :type="type"
      :class="inputClasses"
      :value="value"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="listeners"
      @input="onInput"
      @change="onChange"
    >

    <div
      v-if="iconName"
      class="absolute pin-t flex items-center h-full text-xl"
      :class="$style['icon']"
    >
      <VIcon :name="iconName" />
    </div>
  </div>
</template>

<script>
import { VIcon } from '@c/base'

export default {
  inheritAttrs: false,

  components: {
    VIcon
  },

  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: null
    },
    theme: {
      type: String,
      default: 'primary'
    },
    valid: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    listeners () {
      const listeners = { ...this.$listeners }

      delete listeners.input
      delete listeners.change

      return listeners
    },

    inputClasses () {
      return [
        this.$style['input'],
        ...THEMES[this.theme],
        ...DEFAULT_INPUT_CLASSES,
        {
          'border-success-80': this.valid,
          'border-danger': this.invalid
        }
      ]
    },

    iconName () {
      if (this.invalid) {
        return 'exclamation-circle'
      }

      return this.valid
        ? 'check'
        : null
    }
  },

  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    },
    onChange (event) {
      this.$emit('change', event.target.value)
    }
  }
}

const DEFAULT_INPUT_CLASSES = [
  'w-full',
  'h-8',
  'bg-transparent',
  'appearance-none',
  'border-b',
  'border-solid',
  'border-white',
  'px-3',
  'text-white',
  'outline-none'
]

const THEMES = {
  primary: [],
  danger: [
    'focus:shadow-outline-trasparent',
    'focus:border-danger'
  ]
}
</script>

<style lang="scss" module>
.input {
  min-height: 30px;
}

.icon {
  right: 0px;
}
</style>
